import React from 'react';
import {
    getProspectList,
} from 'api/prospect';
import { Prospect } from 'types/common';


const useMyAllProspectList = (): [Prospect[], boolean, () => void] => {
    const [data, setData] = React.useState<Prospect[]>([]);
    const loading = React.useRef(false);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getProspectList();

            if (!result.error) {
                const _data = result?.data?.data || [];
                setData(_data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData();
        }
    }, []);

    return [data, loading.current, fetchData];
};

export default useMyAllProspectList;
